import React from 'react'
import Artist from './artist/artist'
import Events from './eventList/events'
import ExploreEvents from './exploreEvents/exploreEvents'
import EventSlider from './eventSlider/eventSlider'

const EventBookingHome = () => {
  return (
    <>
        <EventSlider />

        <ExploreEvents />

        <Events />

        <Artist />
    </>
  )
}

export default EventBookingHome;
